<div class="page-wrap height-100 black">
    <div class="session-form-hold">
        <mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>
        <mat-card>
            <mat-card-content>
                <div class="text-center pt-8 pb-16">
                    <img width="100px" height="100px" src="assets/images/icon-euprava.png" alt="" class="mb-05">
                    <p class="text-muted m-0" *ngIf="!failedLogin">{{ 'sessions.ssoLogin.uspesnoLogovanje' | translate }}<br/><br/></p>
                    <p class="text-muted m-0" *ngIf="!failedLogin">{{ 'sessions.ssoLogin.preusmeravanje' | translate }}</p>
                </div>

                <div class="text-center pt-8 pb-16" *ngIf="failedLogin && statusCode == statusCode400">
                    <p class="text-muted m-0">{{ 'features.sessions.ssoLogin.nijePronadjenKorisnickiNalog'| translate }}<br /><br /></p>
                    <p class="text-muted m-0">{{ 'sessions.ssoLogin.obratiteSeAdminu' | translate }}</p>
                </div>
                
                <div class="text-center pt-8 pb-16" *ngIf="failedLogin && statusCode == statusCode500">
                    <p class="text-muted m-0"> {{ 'sessions.ssoLogin.nepredvidjenaGreska' | translate }} <br/><br/></p>
                </div>
                <div *ngIf="failedLogin">
                    <button mat-flat-button class="mat-primary full-width" (click)="backToLoginPage()">
                        {{ 'sessions.ssoLogin.nazad' | translate }}
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>